<script setup lang="ts">
    import { reactive, ref, defineProps, defineEmits } from 'vue';
    import axios from 'axios';

    const props = defineProps({ accessToken: { type: String, required: true } });
    const emit = defineEmits(['passwordRenewed']);

    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        new_password: '',
        confirm_password: '',
    });
    const formErrors = reactive({
        new_password: '',
        confirm_password: '',
    });
    const accessToken = ref('');

    function validate() {
        let isValid = true;

        formErrors.new_password = '';
        if (!formData.new_password) {
            formErrors.new_password ="Le nouveau mot de passe est requis";
            isValid = false;
        }

        formErrors.confirm_password = '';
        if (!formData.confirm_password) {
            formErrors.confirm_password ="Veuillez confirmer le mot de passe";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/auth/renew_expired_password`, formData, {
                headers: {
                    Authorization: `Bearer ${props.accessToken}`
                }
            });
            emit("passwordRenewed");
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
</script>

<template>
    <div>
        <h1 class="font-semibold my-8 text-center">Renouvellement du mot de passe <span class="text-sm text-grey-500"></span></h1>
        <form class="form" @submit.prevent="onSubmit">
            <div class="form-field-floating lg reactive my-5">
                <input type="password" class="form-input" id="new_password" v-model="formData.new_password">
                <label for="new_password">Nouveau Mot de passe <b class="color-danger">*</b></label>
            </div>
            <span v-if="!!formErrors['new_password']" class="text-red">{{ formErrors['new_password'] }}</span>

            <div class="form-field-floating lg reactive my-5">
                <input type="password" class="form-input" id="confirm_password" v-model="formData.confirm_password">
                <label for="password">Confirmer Mot de passe <b class="color-danger">*</b></label>
            </div>
            <div class="mt-7">
                <div v-if="!!errorMessage" class="text-red text-center mb-5">{{ errorMessage }}</div>
                <div class="flex ">
                    <custom-button id="btn-submit" type="submit" :classesList="'btn xl s20'" :loading="loading">
                        <img src="/icons/icon-menu-securite.svg" class="btn-icon" alt="" />
                        <span>Valider</span>
                    </custom-button>
                </div>
            </div>
        </form>
    </div>
</template>
